import React from 'react';
import { TabsNavCore } from '@core-front/tabs';
import Affix from '@telia-front/affix';
import ButtonNavigation from '@telia-front/button-navigation';
import ScrollFade from '@telia-front/scroll-fade';
import Sidemenu from '@telia-front/sidemenu';
import { TabsContext } from './tabs-context';
import TabsNavItem from './tabs-nav-item';
function BEM(props, context) {
    const classArray = [];
    if (context.background) {
        classArray.push('tabs__nav--background-' + context.background);
    }
    if (context.navigationType) {
        classArray.push('tabs__nav--' + context.navigationType);
    }
    if (context.size) {
        classArray.push('tabs__nav--' + context.size);
    }
    if (hasImages(props.items)) {
        classArray.push('tabs__nav--with-icons tabs__nav--icons-top');
    }
    if (hasIcons(props.items)) {
        classArray.push('tabs__nav--with-icons');
    }
    if (props.className) {
        classArray.push(props.className);
    }
    return classArray.join(' ');
}
function hasImages(items) {
    return items.some((i) => !!i.image);
}
function hasIcons(items) {
    return items.some((i) => !!i.icon);
}
const TabsNav = (props) => {
    const context = React.useContext(TabsContext);
    const { navigationType, size, align } = context;
    const innerElement = React.useRef(null);
    function getNavigationTypeTriggers(type, elementRef, ariaLabelledby) {
        const navItems = props.items.map(item => {
            return {
                id: item.id,
                current: item.current || false,
                label: item.text,
                onClick: (event) => {
                    event.preventDefault();
                    if (item.onClick) {
                        item.onClick(event);
                    }
                },
                url: item.url,
                role: 'tab',
                tabIndex: item.current ? 0 : -1,
                'aria-selected': item.current,
                purpose: item.type,
            };
        });
        if (type === 'button-navigation') {
            return (React.createElement(ButtonNavigation, { size: size === 'small' ? 'small' : undefined, align: align === 'left' ? 'left' : 'center', items: navItems, behaviour: "tabs", elementRef: elementRef, "aria-labelledby": ariaLabelledby }));
        }
        else {
            return (React.createElement(Affix, null,
                React.createElement(Sidemenu, { tree: navItems, onTreeChange: /* istanbul ignore next */ () => null, behaviour: "tabs", elementRef: elementRef, "aria-labelledby": ariaLabelledby })));
        }
    }
    const leftFormatter = (el, inner) => {
        if (el.current !== null && inner.current !== null) {
            return el.current.getBoundingClientRect().left - inner.current.getBoundingClientRect().left;
        }
        return 0;
    };
    const widthFormatter = (el) => {
        return el.current !== null ? parseFloat(getComputedStyle(el.current).width) : 0;
    };
    return (React.createElement(TabsNavCore, Object.assign({}, props, { className: BEM(props, context), components: {
            TabsNavItem,
            ScrollFade,
        }, items: !navigationType ? props.items.map(item => item) : [], elementRef: innerElement, leftFormatter: size === 'huge' ? leftFormatter : undefined, widthFormatter: size === 'huge' ? widthFormatter : undefined }), navigationType && getNavigationTypeTriggers(navigationType, innerElement, props['aria-labelledby'])));
};
export { TabsNav as default };
